/** Keep only a decimal number: an optional leading minus and a single dot. */
export function sanitizeDecimalInput(raw: string): string {
  const stripped = raw.replace(/[^0-9.-]/g, "");
  const negative = stripped.startsWith("-");
  const digitsAndDots = stripped.replace(/-/g, "");
  const dotIndex = digitsAndDots.indexOf(".");
  if (dotIndex === -1) return negative ? `-${digitsAndDots}` : digitsAndDots;
  const head = digitsAndDots.slice(0, dotIndex + 1);
  const tail = digitsAndDots.slice(dotIndex + 1).replace(/\./g, "");
  const body = `${head}${tail}`;
  return negative ? `-${body}` : body;
}

/** Parse a sanitised decimal string, or null while it is still incomplete (e.g. "", "-", "."). */
export function parseDecimalInput(clean: string): number | null {
  if (clean === "") return null;
  if (clean === "-") return null;
  if (clean === ".") return null;
  if (clean === "-.") return null;
  const parsed = Number(clean);
  if (!Number.isFinite(parsed)) return null;
  return parsed;
}
